import { ConsentFormDefinition } from '../types';
import { FORM_REGISTRY } from './registry';

let _dynamicForms: Record<string, ConsentFormDefinition> = {};

export function registerDynamicForms(forms: ConsentFormDefinition[]): void {
  _dynamicForms = {};
  for (const form of forms) {
    if (form.formKey) {
      _dynamicForms[form.formKey] = { ...form, isCustomForm: true };
    }
  }
}

// Merges a single form into the registry without wiping other entries.
// Use this when registering a form for preview without a full reload.
export function mergeDynamicForm(form: ConsentFormDefinition): void {
  if (form.formKey) {
    _dynamicForms = { ..._dynamicForms, [form.formKey]: { ...form, isCustomForm: true } };
  } else {
    console.warn('[DynamicRegistry] mergeDynamicForm — skipped form with no formKey, title:', form.title);
  }
}

export function getFormDefinition(key: string): ConsentFormDefinition | undefined {
  return _dynamicForms[key] ?? FORM_REGISTRY[key];
}

export function getAllFormDefinitions(): ConsentFormDefinition[] {
  return [...Object.values(FORM_REGISTRY), ...Object.values(_dynamicForms)];
}

export function getAllFormKeys(): string[] {
  const keys = [...Object.keys(FORM_REGISTRY), ...Object.keys(_dynamicForms)];
  return keys;
}
